
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface SubscriptionOptionsProps {
  form: UseFormReturn<any>;
}

export function SubscriptionOptions({ form }: SubscriptionOptionsProps) {
  const isBusiness = form.watch("isBusiness");
  
  // Pricing constants
  const residentialWeeklyRate = 5;
  const businessWeeklyRate = 20;
  const residentialAnnualPrice = 210;
  const businessAnnualPrice = 840; // £20 * 52 weeks - 20% discount
  
  const weeklyRate = isBusiness ? businessWeeklyRate : residentialWeeklyRate;
  const annualPrice = isBusiness ? businessAnnualPrice : residentialAnnualPrice;
  const weeklyAnnualEquivalent = (weeklyRate * 52).toFixed(2);
  const annualSavings = Math.round((weeklyRate * 52) - annualPrice);
  const savingsPercentage = 20.75;

  return (
    <div className="p-4 rounded-lg border mb-4 bg-gray-50">
      <h3 className="font-medium text-lg mb-2">Subscription Options</h3>
      <p className="text-sm text-gray-500 mb-4">
        Choose your payment plan {isBusiness && "(Business rates apply)"}
      </p>
      
      <FormField
        control={form.control}
        name="isAnnual"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <RadioGroup
                value={field.value ? "annual" : "weekly"}
                onValueChange={(value) => field.onChange(value === "annual")}
                className="flex flex-col space-y-4"
              >
                <div className={`p-4 rounded-lg border bg-white ${!field.value ? "border-primary" : "border-gray-200"}`}>
                  <div className="flex items-center gap-2">
                    <RadioGroupItem value="weekly" id="weekly" />
                    <div>
                      <label htmlFor="weekly" className="font-medium cursor-pointer">
                        Weekly Subscription {isBusiness && "- Per Bin"}
                      </label>
                      <p className="text-sm text-gray-500">
                        £{weeklyRate}/week (£{weeklyAnnualEquivalent}/year)
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className={`p-4 rounded-lg border bg-white ${field.value ? "border-primary" : "border-gray-200"}`}>
                  <div className="flex items-center gap-2">
                    <RadioGroupItem value="annual" id="annual" />
                    <div>
                      <label htmlFor="annual" className="font-medium cursor-pointer">
                        Annual Subscription {isBusiness && "- Per Bin"}
                      </label>
                      <p className="text-sm text-gray-500">£{annualPrice}/year</p>
                      <p className="text-sm font-medium text-green-600">
                        Save £{annualSavings} ({savingsPercentage}% discount)
                      </p>
                    </div>
                  </div>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
